export default __webpack_public_path__ + "533123011b75ad3e6d98afdbcaf3c67d.png";